import { Component, inject, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterItem } from 'app/shared/models/filter-group.models';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { FilterMapper } from 'app/back-office/shared/utilities/filter-mapper';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';
import { VouchersService } from 'app/back-office/shared/services/back-office/vouchers.service';
import { VoucherStatusEnum } from 'app/shared/enums/voucher-status.enum';
import { ShopContextStore } from 'app/shared/state/shop-context.store';

@Component({
    selector: 'app-voucher-filter',
    templateUrl: './voucher-filter.component.html',
    styleUrls: ['./voucher-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VoucherFilterComponent implements OnInit {

  @Input() filter: InternalFilterGroup;
  @Input() accordionState: boolean;
  loaderId = UtilityFunctions.newGuid();

  searchSettings: SearchSettings = {
    placeholder: 'Search voucher...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };

  totalCount = 0;
  searchValue = '';
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [new FilterItem({ text: 'STATUS.ALL', value: null })];

  private _shopContext = inject(ShopContextStore);

  constructor(
    private _vouchers: VouchersService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.accordionState && this.accordionState && this.dataToView.length === 1) {
      this.setDataToView(0);
    }
  }

  ngOnInit(): void {
  }

  onSearch(search: string) {
    this.searchValue = search;
    if (search === '') this.dataToView = [new FilterItem({ text: 'STATUS.ALL', value: null })];
    this.setDataToView(0);
  }

  getNextData(skipCount: number) {
    if (this.totalCount > skipCount) {
      const next = skipCount ? skipCount - 1 : skipCount;
      this.setDataToView(next);
    }
  }

  setDataToView(skipCount: number) {
    const storeId = this._shopContext.currentShop().id;
    this._vouchers.getVouchers(this.loaderId, skipCount, 20, storeId, this.searchValue, null, VoucherStatusEnum.Both ).subscribe(res => {
      this.dataToView = res.items.map(res => FilterMapper.VoucherFilter(res));
      this.totalCount = res.totalCount + 1;
    });
  }
}